import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  TextField,
  Typography,
} from '@mui/material';
import PercentIcon from '@mui/icons-material/Percent';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from 'react';
const PassPercentConfiguration = ({ passPercentage, modifyPassPercentage }) => {
  const [percentage, setPercentage] = useState(passPercentage || 35);
  const [initialPercentage, setInitialPercentage] = useState(
    passPercentage || 35,
  );
  const [Error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setPercentage(passPercentage);
    setInitialPercentage(passPercentage);
    setLoading(false);
  }, [passPercentage]);
  return (
    <>
      <div>
        <Accordion sx={{ borderTop: 0 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            <Box className='flex gap-2'>
              <Box className='size-8 bg-indigo-500 rounded-lg flex items-center justify-center'>
                <PercentIcon className='text-white size-5' />
              </Box>

              <Typography
                variant='h6'
                className='text-indigo-700 font-semibold'
              >
                {' '}
                Configure Pass Percentage
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails className='flex gap-4'>
            <TextField
              InputLabelProps={{ shrink: true }}
              type='number'
              size='small'
              value={percentage}
              label='Enter Percentage'
              onChange={(e) => {
                const value = e.target.value;
                setPercentage(value);
                value >= 1 && value <= 100 ? setError(false) : setError(true);
              }}
              error={Error}
              helperText={Error ? 'Percentage must be between 1 and 100' : ''}
              onKeyDown={(e) => {
                if (['-', '+', 'e', 'E'].includes(e.key)) {
                  e.preventDefault(); // block minus, plus, and scientific notation
                }
              }}
              sx={{
                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                  {
                    display: 'none',
                  },
                minWidth: '200px',
              }}
              inputProps={{
                min: 0,
                max: 100,
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
            ></TextField>
            <div>
              <Button
                variant='contained'
                loading={loading}
                disabled={percentage == initialPercentage || Error}
                onClick={() => modifyPassPercentage(percentage)}
              >
                SUBMIT
              </Button>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};
export default PassPercentConfiguration;
